import SupportWrapper from "@/modules/login/SupportWrapper";
import React from "react";

const SupportPage: React.FC = () => {
  return <SupportWrapper />;
};

export default SupportPage;
